import {RessourceViewerComponent} from "../ressource-viewer/ressource-viewer.component";

export function getClassName(component: string) {
  switch (component) {
    case 'resources-viewer':
      return RessourceViewerComponent;
    default:
      return RessourceViewerComponent;
  }
}
